import React, { useState } from "react";
import { Modal } from "antd";

import {
  ApprovedButton,
  RejectedButton,
  PendingButton,
} from "../../../components/button";

import Spacer from "../../../components/spacer/spacer";

import PhotoModal from "./photomodal";

import images from "../../../assets";

const isImage = (url) => {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
};

const isPDF = (url) => {
  return /\.pdf$/i.test(url);
};

export default function DocumentView(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [item, setitem] = useState({});

  return (
    <>
      {props?.trustbadge?.map((item, index) => (
        <div
          className="trustbadge-document"
          key={index}
          onClick={() => {
            setitem(item);
            setIsModalOpen(true);
          }}
        >
          {isImage(item?.url) ? (
            <img src={item?.signedUrl} alt="" className="trustbadge-doc-img" />
          ) : isPDF(item?.url) ? (
            <iframe
              className="trustbadge-doc-img h-[600px]"
              src={item?.signedUrl}
              title="PDF Document"
            />
          ) : (
            <div className="h-full w-full flex justify-center items-center text-gray-500">
              Unsupported File Type
            </div>
          )}

          <div className="trustbadge-document-info">
            <p className="trustbadge-document-info-file-type">
              {item?.documentType}
            </p>
            <p className="trustbadge-document-info-file-length">
              {props?.trustbadge?.length} file
            </p>
          </div>
          <Spacer height="16px" />
          <div className="flex gap-2 items-center">
            <p>Status: </p>
            {item?.status === "pending" ? (
              <PendingButton />
            ) : item?.status === "rejected" ? (
              <RejectedButton />
            ) : (
              <ApprovedButton />
            )}
          </div>
        </div>
      ))}

      <Modal
        centered={true}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={false}
        closable={false}
        className="gallery-modal-main"
      >
        <PhotoModal
          item={item}
          deleteTrustBadge={props?.deleteTrustBadge}
          ispdf={isPDF(item?.url)}
        >
          <div className="photo-modal-left">
            <h2>{item?.documentType}</h2>
            <p>{props?.trustbadge?.length} Files</p>
          </div>
          <div className="photo-modal-right">
            {/* <img src={images.zoomingIcon} alt="" height={44} width={44} /> */}
            <img
              onClick={() => setIsModalOpen(false)}
              src={images.closeIcon}
              alt=""
              height={44}
              width={44}
            />
          </div>
        </PhotoModal>
      </Modal>
    </>
  );
}
